<template>
  <div>
    <b-row>
      <b-col md="6">
        <Input
          label="Descrição"
          labelBold
          id="name"
          v-model="service.description"
          :error="$v.service.description.$error"
          :maxlength="100"
        />
      </b-col>

      <b-col md="3">
        <InputMoney
          id="price"
          labelBold
          label="Preço R$"
          v-model="service.price"
          :max="21"
        />
      </b-col>

      <b-col md="3">
        <Input
          label="Referência"
          labelBold
          id="reference"
          v-model="service.reference"
          :maxlength="30"
        />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col md="4">
        <autocomplete-group v-model="service.group" />
      </b-col>
      <b-col md="4">
        <autocomplete-unit-of-measure
          v-model="service.unitOfMeasure"
          :error="$v.service.unitOfMeasure.$error"
          default-un
        />
      </b-col>
      <b-col md="2">
        <Input
          label="Data de Cadastro"
          labelBold
          id="dateRegistration"
          :value="dateRegistration"
          disabled
        />
      </b-col>
      <b-col md="2">
        <Input
          label="Última venda"
          labelBold
          id="lastSellDate"
          v-model="lastSellDate"
          disabled
        />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col md="12">
        <TextField
          label="Observações"
          labelBold
          id="observation"
          v-model="service.observation"
          :maxlength="255"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { InputMoney, TextField, Input } from '@/components/Form';
import { mapState } from 'vuex';
import AutocompleteGroup from '@/modules/Inventory/modules/Shared/components/AutocompleteGroup';
import AutocompleteUnitOfMeasure from '@/modules/Inventory/modules/Shared/components/AutocompleteUnitOfMeasure';
import { required, requiredIdProp } from '@/reusable';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';

export default {
  name: 'FormRegister',
  mixins: [FormatMixin],
  components: {
    AutocompleteGroup,
    AutocompleteUnitOfMeasure,
    TextField,
    InputMoney,
    Input,
  },
  validations: {
    service: {
      description: { required },
      unitOfMeasure: { requiredIdProp },
    },
  },
  computed: {
    ...mapState('service', ['service']),

    dateRegistration() {
      return this.formatDate(this.service.createdAt);
    },
    lastSellDate() {
      return this.formatDate(this.service.lastSellDate);
    },
  },
};
</script>
